import { app } from "../config/config";

export const handleRedirect = (verifier: string) => {
  const currentUrl = new URL(window.location.href);

  const redirectUrl = new URL("login", app.accountUrl);

  currentUrl.searchParams.append("verifier", verifier);

  redirectUrl.searchParams.append("redirect", currentUrl.href);

  window.location.href = redirectUrl.href;
};
